import { render, staticRenderFns } from "./accesoCapacitacion.vue?vue&type=template&id=69880344&scoped=true&"
import script from "./accesoCapacitacion.vue?vue&type=script&lang=js&"
export * from "./accesoCapacitacion.vue?vue&type=script&lang=js&"
import style0 from "./accesoCapacitacion.vue?vue&type=style&index=0&id=69880344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69880344",
  null
  
)

export default component.exports